import { DictType } from '@pma/types';
import * as z from 'zod';

export const projectFormSchema = z
  .object({
    title: z.string().min(1, { message: 'Enter project name' }),
    address: z
      .object({
        name: z.string().min(1, {
          message: 'Enter project address',
        }),
        long: z.number(),
        lat: z.number(),
      })
      .optional(),
    use_gis: z.boolean().optional(),
    type_id: z.string().optional(),
    work_type_id: z.number().optional(),
    neighborhood: z
      .object({
        id: z.number(),
        name: z.string(),
      })
      .optional(),
    status: z
      .object({
        id: z.number(),
        name: z.string(),
      })
      .optional(),
    start_at: z.date().optional(),
    finish_to: z.date().optional(),
    description: z
      .string()
      // .trim()
      // .min(1, {
      //   message: "Enter a description",
      // })
      .optional(),
    construction_name: z
      .string({
        required_error: 'Enter construction name',
      })
      .optional(),
  })
  .refine(
    (data: DictType) => {
      if (data?.start_at) {
        return data?.finish_to >= data?.start_at;
      }

      return true;
    },
    {
      message: 'End date cannot be before start date',
      path: ['finish_to'],
    },
  )
  .refine(
    (data) =>
      !data.use_gis ||
      (data.use_gis &&
        data?.address?.name &&
        data?.address?.name?.trim()?.length > 0),
    {
      message: 'Address is required when using GIS',
      path: ['address'],
    },
  );

export type ProjectFormValues = z.infer<typeof projectFormSchema>;
